import { api } from "@/lib/api";
import type { SearchResults } from "@/types/types";

export const searchService = {
  search: (q: string) => api<SearchResults>(`/api/search?q=${encodeURIComponent(q)}`),
  suggest: (q: string) => api<string[]>(`/api/search/suggest?q=${encodeURIComponent(q)}`),
};
